module.exports = __webpack_public_path__ + "fa26412375164e85a55c54157f2e4dc8.jpg";